"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipOnOverflow = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const __1 = require("..");
/** This component has text wrapping turned off and overflow set to ellipsis.
 * If its content is wider than its displayed width, it will display `title`, or its text content if `title` is not provided, in a browser-native tooltip. */
const TooltipOnOverflow = ({ title, children, style, }) => (react_1.default.createElement("div", { style: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        ...style,
    }, onMouseEnter: ({ currentTarget: element }) => {
        if (element.clientWidth < element.scrollWidth ||
            element.clientHeight < element.scrollHeight) {
            element.title = (0, __1.trimPunctuation)(title || element.textContent || "");
        }
    } }, children));
exports.TooltipOnOverflow = TooltipOnOverflow;
//# sourceMappingURL=TooltipOnOverflow.js.map